import { render } from "./ImgLinhaBQuemSomos.vue?vue&type=template&id=1cca6d4b&scoped=true"
import script from "./ImgLinhaBQuemSomos.vue?vue&type=script&lang=js"
export * from "./ImgLinhaBQuemSomos.vue?vue&type=script&lang=js"

import "./ImgLinhaBQuemSomos.vue?vue&type=style&index=0&id=1cca6d4b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cca6d4b"]])

export default __exports__